import { memorySegmentId } from '../families/memory-layout.js';
import type { MemoryLayoutSpec } from '../model.js';

export function memoryLayoutFixture(
  width = 640,
  stress = false,
  focusSegmentId?: string,
): MemoryLayoutSpec {
  return {
    id: stress ? 'memory-layout-stress' : 'memory-layout',
    family: 'memory-layout',
    view: 'orthographic',
    viewport: { width, height: 470 },
    baseAddress: stress ? '0x000000c00001ffa0' : '0x000000c000010000',
    wordBytes: 8,
    typeName: stress ? 'ReplicatedCustomerCacheEntry' : 'AccountSnapshot',
    segments: stress
      ? [
          { id: 'runtime-header', label: 'runtime type header pointer', bytes: 8, kind: 'header', value: 'gc/type' },
          { id: 'customer-display-name', label: 'customer display name bytes', bytes: 12, kind: 'field', value: 'Ada Lovelace' },
          { id: 'retry-policy-enabled', label: 'retry policy enabled flag', bytes: 1, kind: 'field', value: 'true' },
          { id: 'cache-line-alignment-padding', label: 'cache line alignment padding', bytes: 3, kind: 'padding' },
          { id: 'monotonic-revision-counter', label: 'monotonic revision counter', bytes: 4, kind: 'field', value: 1048576 },
          { id: 'integrity-checksum', label: 'integrity checksum', bytes: 4, kind: 'field', value: '7fd4a901' },
        ]
      : [
          { id: 'account-id', label: 'accountID', bytes: 8, kind: 'field', value: 42 },
          { id: 'enabled', label: 'enabled', bytes: 1, kind: 'field', value: 'true' },
          { id: 'alignment-gap', label: 'implicit alignment padding', bytes: 7, kind: 'padding' },
          { id: 'balance', label: 'balanceCents', bytes: 8, kind: 'field', value: 12500 },
        ],
    ...(focusSegmentId ? { focusSegmentId } : {}),
    provenance: 'Go-style struct layout teaching fixture · byte offsets and padding are explicit semantic data',
  };
}

export const defaultMemoryFocus = memorySegmentId('alignment-gap');
